<template>
  <div class="wrapper">
    <van-nav-bar
      title="修改邮箱"
      left-text="返回"
      left-arrow
      @click-left="goback()"
    />
    <div class="MyCenter1 mt-4">
      <b-row style="margin-right: 0; margin: 0 auto">
        <b-col cols="12">
          <b-form-group class="col-md-2 mb-3" label="本机号码">
            <b-form-input v-model="form.tel" disabled></b-form-input>
          </b-form-group>
          <b-form-group class="col-md-2 mb-3" label="验证码">
            <b-row>
              <b-col cols="8">
                <b-form-input
                  v-model="form.telCode"
                  placeholder="验证码"
                ></b-form-input>
              </b-col>
              <b-col cols="4">
                <b-button
                  v-if="countTime1 == 0"
                  @click="sendCode(2)"
                  style="height: 34px; margin-top: 20px"
                  class="p-0 m-0 w-100 text-10"
                  variant="primary ripple m-1"
                  >发送验证码</b-button
                >
                <b-button
                  v-else
                  style="height: 34px; margin-top: 20px"
                  class="p-0 m-0 w-100 text-10"
                  variant="secondary ripple m-1"
                  >{{ countTime1 }}</b-button
                >
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group class="col-md-2 mb-3" label="新邮箱">
            <b-form-input
              v-model="form.email"
              placeholder="请输入新邮箱"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="col-md-2 mb-3" label="确认邮箱">
            <b-form-input
              v-model="form.confirmEmail"
              placeholder="请输入确认邮箱"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="text-center col-md-12">
            <b-button @click="selecket" variant="primary btn-block" class="mt-4"
              >确认</b-button
            >
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "changeMail",
  components: {},
  data() {
    return {
      countTime1: 0,
      timer1: null,
      form: {
        tel: "",
        telCode: "",
        email: "",
        confirmEmail: "",
      },
    };
  },
  beforeDestroy() {
    clearInterval(this.timer1); // 清除定时器
    this.timer1 = null;
  },
  created() {
    this.form.tel = JSON.parse(
      localStorage.getItem("userInfo")
    ).currentUser.tel;
  },
  methods: {
    selecket() {
      this.request({
        url: "/v1.0/ThePublic/userChangeEmail",
        method: "POST",
        data: this.form,
      }).then((res) => {
        if (res.success) {
          this.$toast.success("修改成功");
          localStorage.removeItem("userInfo");
          location.reload();
        }
      });
    },
    sendCode() {
      this.request({
        url: "/v1.0/Account/userSendCode",
        method: "POST",
        data: {
          tel: this.form.tel,
        },
      }).then((res) => {
        if (res.success) {
          this.codeTime();
        }
      });
    },
    codeTime() {
      this.countTime1 = 60;
      this.timer1 = setInterval(() => {
        this.countTime1 -= 1;
        if (this.countTime1 == 0) {
          clearInterval(this.timer1);
        }
      }, 1000);
    },
    goback() {
      var $this = this;
      $this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
</style>